/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteAnthropicInferenceConfigSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAnthropicInferenceConfigRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteAnthropicInferenceConfigSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAnthropicInferenceConfigSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteAnthropicInferenceConfigSecurity$Outbound,
    DeleteAnthropicInferenceConfigSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteAnthropicInferenceConfigSecurityToJSON(
  deleteAnthropicInferenceConfigSecurity:
    DeleteAnthropicInferenceConfigSecurity,
): string {
  return JSON.stringify(
    DeleteAnthropicInferenceConfigSecurity$outboundSchema.parse(
      deleteAnthropicInferenceConfigSecurity,
    ),
  );
}

/** @internal */
export type DeleteAnthropicInferenceConfigRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAnthropicInferenceConfigRequest$outboundSchema:
  z.ZodMiniType<
    DeleteAnthropicInferenceConfigRequest$Outbound,
    DeleteAnthropicInferenceConfigRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
      });
    }),
  );

export function deleteAnthropicInferenceConfigRequestToJSON(
  deleteAnthropicInferenceConfigRequest: DeleteAnthropicInferenceConfigRequest,
): string {
  return JSON.stringify(
    DeleteAnthropicInferenceConfigRequest$outboundSchema.parse(
      deleteAnthropicInferenceConfigRequest,
    ),
  );
}
